import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

interface HeaderProps {
  title?: string;
  subtitle?: string;
  showLogo?: boolean;
  showBackButton?: boolean;
  backPath?: string;
  className?: string;
}

const Header: React.FC<HeaderProps> = ({ 
  title, 
  subtitle, 
  showLogo = true,
  showBackButton = false,
  backPath = '/dashboard',
  className = '' 
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(backPath);
  };

  return (
    <header className={`px-mobile py-mobile safe-area-top ${className}`}>
      <div className="flex items-center justify-between mb-4 sm:mb-6">
        {/* 뒤로가기 버튼 또는 로고 */}
        {showBackButton ? (
          <button
            onClick={handleBack}
            className="flex items-center space-x-2 btn-ghost group"
            aria-label="뒤로가기"
          >
            <ArrowLeft className="w-5 h-5 text-sparrow-600 group-hover:text-sparrow-700 transition-colors" />
            <span className="text-sm font-medium text-sparrow-600 group-hover:text-sparrow-700">
              돌아가기
            </span>
          </button>
        ) : showLogo ? (
          <div className="flex items-center space-x-3">
            <div className="logo w-10 h-10 sm:w-12 sm:h-12 rounded-xl shadow-soft"></div>
            <div className="hidden sm:block">
              <h1 className="text-lg font-bold text-sparrow-800">Sparrow</h1>
              <p className="text-xs text-neutral-600">개인성장 앱</p>
            </div>
          </div>
        ) : null}
        
        {/* 제목과 부제목 */}
        {(title || subtitle) && (
          <div className={`${showLogo || showBackButton ? 'text-right' : 'text-left'} flex-1`}>
            {title && (
              <h1 className="text-2xl sm:text-3xl font-bold text-sparrow-800 mb-1 sm:mb-2">
                {title}
              </h1>
            )}
            {subtitle && (
              <p className="text-sm sm:text-lg text-neutral-600">
                {subtitle}
              </p>
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header; 